import React from 'react';

import { TitleWithDescription, AvatarIcon } from '@infoods/lifebase-ui';

import classes from './CoachPerformanceItem.module.scss';
import { CoachPerformanceData } from '../../../../../interfaces/entity-dashboard/CoachPerformanceData';
import { getPriceView } from '../../../../../../shared/utils/stringUtils';
import { DiffPercentLabel } from '../../../../../../shared/components/ui-components/DiffPercentLabel/DiffPercentLabel';
import { getFormattedDate } from '../../../../../../shared/utils/dateUtils';
import { localDataFormat } from '../../../../../../shared/constants/apiDateFormat';

type CoachPerformanceItemProps = {
  item: CoachPerformanceData;
};

const CoachPerformanceItem = ({ item }: CoachPerformanceItemProps) => {
  const fullName = `${item.firstName} ${item.lastName}`;
  return (
    <div className={classes.container}>
      <div className={classes.coachPersonalInfo}>
        <AvatarIcon userName={fullName} avatarImgLink={item.avatar} size="small" />
        <TitleWithDescription
          title={fullName}
          titleFont="body-14-bold"
          description={
            <p className={classes.description}>
              Active since:&nbsp;
              <span>{getFormattedDate(item.activeSince, localDataFormat)}</span>
            </p>
          }
        />
      </div>
      <div className={classes.revenueInfo}>
        <div className={classes.revenueValueContainer}>
          <p className={classes.revenueValue}>{getPriceView(item.revenue.value / 100)}</p>
          <DiffPercentLabel percentValue={item.revenue.diffPercent} />
        </div>
        <p className={classes.activeUsers}>{item.activeUsers} active users</p>
      </div>
    </div>
  );
};

export { CoachPerformanceItem };
